module.exports = __webpack_public_path__ + "img/4.7082fb45.jpg";